import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../app-constants';

@Injectable({
  providedIn: 'root'
})
export class ItemService {

  constants: any = Constants;

  constructor(private http: HttpClient) { }

  item() {
    return this.http.get(`${this.constants.api}/item`);
  }

  save(data) {
    return this.http.post(`${this.constants.api}/item`, data);
  }

  remove(id) {
    return this.http.delete(`${this.constants.api}/item/${id}`);
  }

  edit(data) {
    return this.http.put(`${this.constants.api}/item`, data);
  }
}
